import { useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import RemainedDaysChip from './RemainedDaysChip';
import { ProcessedLeaveYear } from '../../shared/types';
import { useDateService } from 'framework/utils';
import { useListContext } from 'framework/list';

const PaidLeavesSectionHeader = () => {
  const { data: { items = [] } = {} } = useListContext();
  const { getCurrentDate } = useDateService();
  const currentDate = getCurrentDate().toDate();

  const currentPeriod = useMemo(() => {
    return (items as ProcessedLeaveYear[]).find(item => {
      const startDate = new Date(item.startDate);
      const endDate = new Date(item.endDate);
      return startDate <= currentDate && endDate >= currentDate;
    });
  }, [items, currentDate]);

  const totalPaidLeavesBalance = currentPeriod?.totalRemainedBalance || '0';
  const currentPeriodDayOnDemands = currentPeriod?.dayOnDemandsRemainedBalance || '0';
  const shouldShowDayOnDemandBalance = currentPeriod?.hasDayOnDemandBalance && currentPeriod?.dayOnDemandsTotalBalance;
  const isPolishContractor = items.some(item => item.isPolishContractor);

  return (
    <Box display="flex" alignItems="anchor-center" gap={2}>
      <Typography variant="h4" color="primary">
        Paid leaves
      </Typography>
      {!isPolishContractor &&
        (shouldShowDayOnDemandBalance ? (
          <RemainedDaysChip label={`${totalPaidLeavesBalance}d / ${currentPeriodDayOnDemands}d on demand`} />
        ) : (
          <RemainedDaysChip label={`${totalPaidLeavesBalance}d`} />
        ))}
    </Box>
  );
};

export default PaidLeavesSectionHeader;
